import helpPointService from "../service/helpPointService";
import {HelpPointLinkIdentifier} from "../model";

export const FETCH_HELP_POINT_CATEGORIES = {
	REQUEST: "FETCH_HELP_POINT_CATEGORIES_REQUEST",
	SUCCESS: "FETCH_HELP_POINT_CATEGORIES_SUCCESS",
	FAILURE: "FETCH_HELP_POINT_CATEGORIES_FAILURE",
};

export const FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS = {
	REQUEST: "FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS_REQUEST",
	SUCCESS: "FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS_SUCCESS",
	FAILURE: "FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS_FAILURE",
};

export const FETCH_HELP_POINT_VIDEO_DETAILS = {
	REQUEST: "FETCH_HELP_POINT_VIDEO_DETAILS_REQUEST",
	SUCCESS: "FETCH_HELP_POINT_VIDEO_DETAILS_SUCCESS",
	FAILURE: "FETCH_HELP_POINT_VIDEO_DETAILS_FAILURE",
};

export const FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID = {
	REQUEST: "FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID_REQUEST",
	SUCCESS: "FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID_SUCCESS",
	FAILURE: "FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID_FAILURE",
};

export const FETCH_HELP_POINT_LINK_BY_IDENTIFIER = {
	REQUEST: "FETCH_HELP_POINT_LINK_BY_IDENTIFIER_REQUEST",
	SUCCESS: "FETCH_HELP_POINT_LINK_BY_IDENTIFIER_SUCCESS",
	FAILURE: "FETCH_HELP_POINT_LINK_BY_IDENTIFIER_FAILURE"
};

export const OPEN_HELP_POINT_PAGE = "OPEN_HELP_POINT_PAGE";

export const getHelpPointCategories = () => {
	return async dispatch => {
		dispatch({type: FETCH_HELP_POINT_CATEGORIES.REQUEST});
		try {
			const helpPointCategories = await helpPointService.getCategories();
			dispatch({
				type: FETCH_HELP_POINT_CATEGORIES.SUCCESS,
				payload: helpPointCategories
			});
		} catch (e) {
			dispatch({type: FETCH_HELP_POINT_CATEGORIES.FAILURE});
			console.error(e);
		}
	};
};

export const getNewestHelpPointPlaylistItems = () => {
	return async dispatch => {
		dispatch({type: FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.REQUEST});
		try {
			const helpPointPlaylistItems = await helpPointService.getNewestPlaylistItems();
			dispatch({
				type: FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.SUCCESS,
				payload: helpPointPlaylistItems
			});
		} catch (e) {
			dispatch({type: FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.FAILURE});
			console.error(e);
		}
	};
};

export const getHelpPointVideoDetails = (id: number, categoryNumber: number) => {
	return async dispatch => {
		dispatch({type: FETCH_HELP_POINT_VIDEO_DETAILS.REQUEST});
		try {
			const helpPointVideo = await helpPointService.getVideoDetails(id);
			dispatch({
				type: FETCH_HELP_POINT_VIDEO_DETAILS.SUCCESS,
				payload: {
					...helpPointVideo,
					categoryNumber
				}
			});
		} catch (e) {
			dispatch({type: FETCH_HELP_POINT_VIDEO_DETAILS.FAILURE});
			console.error(e);
		}
	};
};

export const getHelpPointVideoPlaylist = (id: number) => {
	return async dispatch => {
		dispatch({type: FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.REQUEST});
		try {
			const helpPointPlaylist = await helpPointService.getPlaylistByVideoId(id);
			dispatch({
				type: FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.SUCCESS,
				payload: helpPointPlaylist
			});
		} catch (e) {
			dispatch({type: FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.FAILURE});
			console.error(e);
		}
	};
};

export const getHelpPointLinkByIdentifier = (helpPointLocation: HelpPointLinkIdentifier) => {
	return async dispatch => {
		dispatch({ type: FETCH_HELP_POINT_LINK_BY_IDENTIFIER.REQUEST });

		try {
			const helpPointLink = await helpPointService.getHelpPointLinkByIdentifier(helpPointLocation);

			dispatch({
				type: FETCH_HELP_POINT_LINK_BY_IDENTIFIER.SUCCESS,
				payload: helpPointLink
			});
		} catch (e) {
			dispatch({ type: FETCH_HELP_POINT_LINK_BY_IDENTIFIER.FAILURE });
			console.error("Failed to fetch playlist item or view status", e);
		}
	};
};

export const openHelpPointPage = () => {
	return async dispatch => {
		dispatch({type: OPEN_HELP_POINT_PAGE});
	};
};